import { useUserWithoutStore } from './store/modules/user'
import { useGlobalWithoutStore } from './store/modules/global'
import { setupStore } from './store'
import { setupComponent } from './components/setup-component'
import { createApp } from 'vue'
import './styles/app.css'
import 'windi.css'
import './assets/icon-font/iconfont.css' // 解决H5样式引入问题
import './assets/nut-icon-font/iconfont.css' // 解决H5样式引入问题
import setupUpdateCheck from './common/update-check'
import { fixArray } from './common/fixArray'
import { loadEcharts } from 'echarts4taro3'
import * as echarts from './assets/echarts/echarts'
import { isWeChatMiniProgram } from './common/isWeixin'
// import { setupFundebug } from './common/debug'

const globalStore = useGlobalWithoutStore()
const userStore = useUserWithoutStore()

const checkAndUploadVersion = () => {
  if (isWeChatMiniProgram()) {
    if (wx.canIUse('getUpdateManager')) {
      const updateManager = wx.getUpdateManager()
      updateManager.onCheckForUpdate(res => {
        // 请求完新版本信息的回调
        if (res.hasUpdate) {
          updateManager.onUpdateReady(() => {
            wx.showModal({
              title: '更新提示',
              content: '新版本已经准备好，是否重启应用？',
              success(res) {
                if (res.confirm) {
                  // 新的版本已经下载好，调用 applyUpdate 应用新版本并重启
                  updateManager.applyUpdate()
                }
              }
            })
          })
          updateManager.onUpdateFailed(() => {
            // 新的版本下载失败
            wx.showModal({
              title: '已经有新版本了哟~',
              content: '新版本已经上线啦~，请您删除当前小程序，重新搜索打开哟~'
            })
          })
        }
      })
    }
  }
}

const app = createApp({

  onLaunch() {
    fixArray() // 修复数组at()方法
    globalStore.setReference()
    loadEcharts(echarts)
    setupUpdateCheck()
    // console.log(process.env.NODE_ENV)
    // globalStore.setSystemInfo()
    // globalStore.setMiniProgramInfo() // 设置小程序信息
    if (userStore.token) {
      userStore.setUserInfo()
    }
    checkAndUploadVersion()

    /*       console.log(useEnv, 'useEnv') */
  },
})


setupComponent(app)
setupStore(app)
// setupFundebug(app)
export default app
